import React, { useEffect, useState } from 'react';
import './NoticeBoard.css';

const NoticeBoard = () => {
  const [notices, setNotices] = useState([]);

  useEffect(() => {
    fetch('/News.txt')
      .then(res => res.text())
      .then(data => {
        // Expecting format per line: Notice text | link (optional)
        const lines = data
          .split('\n')
          .map(line => line.trim())
          .filter(line => line.length > 0)
          .map(line => {
            const parts = line.split('|').map(p => p.trim());
            return { text: parts[0], link: parts[1] || null };
          });
        setNotices(lines);
      })
      .catch(err => console.error('Error loading News.txt:', err));
  }, []);

  const shouldScroll = notices.length > 4;

  return (
    <div className="notice-wrapper">
      <h2 className="notice-title">📌 News / Notices</h2>
      <div className="notice-board">
        <div
          className={`notice-list ${shouldScroll ? 'scrolling' : ''}`}
          style={shouldScroll ? {'--notice-count': notices.length} : {}}
        >
          {[...notices, ...notices].map((notice, index) => (
            <div key={index} className="notice-item">
              <span className="dot" />
              <span className="notice-text">{notice.text}</span>
              {notice.link && (
                <a
                  href={notice.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="notice-link"
                  title="Open related link"
                >
                  🔗
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NoticeBoard;
